export default class FormHandler {
    fullPageSpinner = document.querySelector(".full-page-spinner-overlay");

    constructor(formElement) {
        if (formElement) {
            this.formElement = formElement;
            this.rowId = 0;
            //this.row = '';
            this.listId = 0;
            this.itemId = 0;
            //Optional Chaining
            this.modalDiv = this.formElement?.closest(".modal");
            
            if (this.modalDiv) {

                this.modal = new bootstrap.Modal(this.modalDiv);

                this.modalContent =
                    this.modalDiv?.querySelector(".modal-content");
                this.modalBody = this.modalDiv?.querySelector(".modal-body");
            }

            this.notifyModalDiv = document.getElementById(
                "wcpl_notification_modal"
            );

            this.formElement.addEventListener(
                "submit",
                this.submitForm.bind(this)
            );

            if (this.notifyModalDiv)
                this.notifyModal = bootstrap.Modal.getOrCreateInstance(
                    this.notifyModalDiv
                );
        }
    }

    hideModal() {
        if (this.modal) {

            this.modal.hide();

            // this.modalDiv.classList.remove("show");
            // this.modalBody.classList.remove("show-overlay");

        }
    }
    
    addSpinner() {
        this.modalContent?.insertAdjacentHTML('beforeend', this.getSpinnerHtml());
    }

    removeSpinner() {
        this.modalContent?.querySelector('.add-item-spinner').remove();
    }


    showFullPageSpinner() {
        this.fullPageSpinner.style.display = "flex";
    }

    hideFullPageSpinner() {
        this.fullPageSpinner.style.display = "none";
    }

    showMiniCart() {
        const modalMiniCart = bootstrap.Offcanvas.getOrCreateInstance(
            document.getElementById("cart_modal")
        );

        modalMiniCart?.show();
    }

    refreshCartFragments(data) {

        document.querySelector(".mini-cart").innerHTML =
            data.fragments["div.widget_shopping_cart_content"];

        document.querySelector(".cart-icon-container").innerHTML =
            data.fragments["a.cart-contents"];
    }

    showNotificationModal(title, message) {
        if (this.notifyModalDiv) {
            this.notifyModalDiv.querySelector(".modal__title").innerHTML =
                title;
            this.notifyModalDiv.querySelector(".modal__message").innerHTML =
                message;
            this.notifyModal.show();
        }
    }

    getSpinnerHtml() {
        return `<div class="add-item-spinner">
                <div class="spinner-border text-primary" role="status"></div>
                </div>`;
    }

    buildFormQueryString() {
        const formData = new FormData(this.formElement);
        return new URLSearchParams(formData);
    }

    async submitForm(event) {
        const submitBtn = event.submitter;

        try {
            event.preventDefault();

            const form = this.formElement;
            const queryStringParams = this.buildFormQueryString();

            form.classList.add("was-validated");

            if (form.checkValidity()) {
                submitBtn.disabled = true;
                this.addSpinner();

                const repsonse = await fetch(ahx_public.ajax_url, {
                    method: "post",
                    body: queryStringParams,
                });

                const data = await repsonse.text();

                submitBtn.disabled = false;
                this.removeSpinner();
                this.hideModal();

                return JSON.parse(data);
            }
        } catch (error) {
            throw new Error(error);
        }
    }
}
